export default __webpack_public_path__ + "static/media/Smoke_sensor.9e31dca4.svg";